import { ClinicInformationRequest } from 'src/models/clinic';
import { fetchApi } from '../baseApi';

// New Step02
export function submitClinicInformation(request: ClinicInformationRequest) {
    return new Promise((resolve, reject) => {
        fetchApi(`api/registrations/submit_clinic_information`, 'POST', request).then((result) => {
            resolve(result);
        }).catch((e) => {
            reject(new Error('Cannot submit clinic information!'));
        });
    });
}


// WEBPACK FOOTER //
// ./src/api/clinic/index.ts